<app-navbar-style-three></app-navbar-style-three>

<section class="administration-section">
  <div class="container">
    <!-- Header -->
    <div class="section-header">
      <h1 class="section-header__title">Leadership</h1>
      <!-- <p class="section-header__subtitle">Leadership</p> -->
    </div>

    <!-- Main Content Area -->
    <div class="administration-content" *ngIf="!fetchinData">
      <!-- Empty State -->
      <div class="empty-state" *ngIf="LeadershipInfo == null || LeadershipInfo.length === 0">
        <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
          <path
            d="M22 10V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V10"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 10H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 14V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="empty-state__text">No leadership records found</p>
      </div>

      <!-- Grid -->
      <div class="team-grid" *ngIf="LeadershipInfo != null && LeadershipInfo.length > 0">
        <article class="team-card" *ngFor="let item of LeadershipInfo; let i = index" [attr.data-index]="i">
          <div class="team-card__image-wrapper">
            <img [src]="item.ImagePath" [alt]="item.Name" class="team-card__image" loading="lazy" />
          </div>
          <div class="team-card__content">
            <h3 class="team-card__name">{{ item.Name }}</h3>
            <p class="team-card__position" *ngIf="item.GBDesignation">{{ item.GBDesignation }}</p>
            <div class="team-card__badge-wrapper" *ngIf="item.GBPosition">
              <span class="team-card__badge-pill">{{ item.GBPosition }}</span>
            </div>
          </div>
        </article>
      </div>
    </div>

    <!-- Loading Skeleton -->
    <div class="loading-state" *ngIf="fetchinData">
      <div class="team-grid">
        <div class="team-card" *ngFor="let i of [1,2,3,4,5,6,7,8]" style="border-color: #d1fae5;">
          <div class="skeleton" style="width: 140px; height: 145px; border-radius: 8px; margin: 0 auto 18px;"></div>
          <div class="skeleton" style="width: 75%; height: 20px; border-radius: 4px; margin-bottom: 8px;"></div>
          <div class="skeleton" style="width: 50%; height: 16px; border-radius: 4px; margin-bottom: 16px;"></div>
          <div class="skeleton" style="width: 110px; height: 26px; border-radius: 50px; margin-top: auto;"></div>
        </div>
      </div>
    </div>
  </div>
</section>
